import React, { useState, useEffect, useMemo } from 'react';
import { Search, Users } from 'lucide-react';
import { guestsAPI } from '../../services/api';
import { useLanguage } from '../../context/LanguageContext';
import toast from 'react-hot-toast';

export default function Guests() {
  const [guests, setGuests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const { t } = useLanguage();

  useEffect(() => {
    guestsAPI.getAll()
      .then(res => setGuests(res.data.data))
      .catch(() => toast.error('Failed to load guests'))
      .finally(() => setLoading(false));
  }, []);

  const filtered = useMemo(() => {
    const q = search.toLowerCase();
    if (!q) return guests;
    return guests.filter(g =>
      g.full_name?.toLowerCase().includes(q) ||
      g.id_number?.toLowerCase().includes(q)
    );
  }, [guests, search]);

  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'60vh' }}>
      <span className="spinner" style={{ width:32, height:32, borderWidth:3 }} />
    </div>
  );

  return (
    <div>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:28 }}>
        <div>
          <h1 style={{ fontSize:28, fontWeight:800, marginBottom:4 }}>{t('guests.title')}</h1>
          <p style={{ color:'var(--text-secondary)', fontSize:14 }}>{t('guests.count', guests.length)}</p>
        </div>
      </div>

      <div style={{ position:'relative', marginBottom:20, maxWidth:360 }}>
        <Search size={15} style={{ position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:'var(--text-muted)' }} />
        <input
          placeholder={t('guests.searchPlaceholder')}
          value={search}
          onChange={e => setSearch(e.target.value)}
          style={{ paddingLeft:36 }}
        />
      </div>

      <div className="card" style={{ padding:0, overflow:'hidden' }}>
        {filtered.length === 0 ? (
          <div className="empty-state">
            <Users size={48} />
            <h3>{t('guests.noGuests')}</h3>
            <p>{search ? t('guests.noGuestsSearch') : t('guests.noGuestsEmpty')}</p>
          </div>
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>{t('table.fullName')}</th>
                <th>{t('table.nationality')}</th>
                <th>{t('table.idType')}</th>
                <th>{t('table.idNumber')}</th>
                <th>{t('table.phone')}</th>
                <th>{t('table.email')}</th>
                <th>{t('table.bookings')}</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map(g => (
                <tr key={g.id}>
                  <td style={{ fontWeight:500 }}>{g.full_name}</td>
                  <td style={{ color:'var(--text-secondary)' }}>{g.nationality || '—'}</td>
                  <td><span className="badge badge-accent" style={{ fontSize:11 }}>{g.id_type}</span></td>
                  <td style={{ color:'var(--text-secondary)', fontFamily:'monospace', fontSize:13 }}>{g.id_number || '—'}</td>
                  <td style={{ color:'var(--text-secondary)' }}>{g.phone || '—'}</td>
                  <td style={{ color:'var(--text-secondary)' }}>{g.email || '—'}</td>
                  <td>
                    <span className={`badge ${g.booking_count > 0 ? 'badge-success' : 'badge-warning'}`}>
                      {g.booking_count}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
